import moment from 'moment';
import { twentyFourHourTimePadded } from '../constants/timezone-format';

export const isValidISOString = (str) => moment(str, moment.ISO_8601, true).isValid();

export const formatTimeFrom24Hour = (time, timeFormat) => {
  if (!time) {
    return null;
  }
  return moment(time, 'hh:mm:ss').format(timeFormat);
};

export const formatTimeTo24Hour = (time, timeFormat) => {
  if (!time) {
    return null;
  }
  return moment(time, timeFormat).format(twentyFourHourTimePadded);
};
